import axios from 'axios';

export default axios.create({
  // validateStatus: (status) => status < 500,
  baseURL: 'https://api.vegas.prod.lasvegasenvivo.com',
});
